import React from 'react';
import { createRoot } from 'react-dom/client';
import {HashRouter, Route, Switch, Redirect} from 'react-router-dom';
import {createBrowserHistory} from 'history';

import {composeWithDevTools} from "redux-devtools-extension";
import {applyMiddleware, combineReducers, createStore} from "redux";
import thunkMiddleware from "redux-thunk";
import {Provider} from "react-redux";
import { toast } from 'react-toastify';

import dashboardReducer from "./dashboard/reducer";
import scheduledReplenishmentReducer from "./scheduledreplenishment/reducer";
import replenishmentReducer from "./replenishment/reducer";
import retailerReducer from "./retailer/reducer";
import moduleReducer from "./module/overview/reducer";
import moduleAdminReducer from "./module/admin/reducer";
import areaControlOverviewReducer from "./areacontrol/overview/reducer";
import areaControlAdminReducer from "./areacontrol/admin/reducer";
import userReducer from "./user/reducer";
import securityReducer from './security/reducer';
import articleReducer from "./article/reducer";

// Containers
import App from './App'
import securedAccess from './security/SecuredComponent';
import LoginComponent from './security/LoginComponent';
import LogoutComponent from './security/LogoutComponent';

// Styles
// Import Font Awesome Icons Set
import '@fortawesome/fontawesome-free/css/all.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';

import "react-toastify/dist/ReactToastify.css";

// Import Main styles for this application
import '../../scss/style.scss'
import '../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import 'react-datetime/css/react-datetime.css';

const rootReducer = combineReducers({
    dashboard: dashboardReducer,
    scheduledReplenishment: scheduledReplenishmentReducer,
    replenishment: replenishmentReducer,
    retailer: retailerReducer,
    module: moduleReducer,
    moduleAdmin: moduleAdminReducer,
    areacontrol: areaControlOverviewReducer,
    areacontrolAdmin: areaControlAdminReducer,
    user: userReducer,
    article: articleReducer,
    security: securityReducer
});

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunkMiddleware)));

const history = createBrowserHistory();

toast.configure()

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <HashRouter history={history}>
            <Switch>
                <Route path="/admin" name="Home" component={securedAccess(App)}/>
                <Route path='/login' component={LoginComponent}/>
                <Route path='/logout' component={LogoutComponent}/>
                <Redirect from="/" to="/admin"/>
            </Switch>
        </HashRouter>
    </Provider>
);



// WEBPACK FOOTER //
// ./src/admin/admin.js